import api from './api';

// Get system statistics
export const getSystemStats = async () => {
  const response = await api.get('/api/statistics');
  return response.data;
};
